var R = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var b = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable;
var l = (e, a, t) => a in e ? R(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, p = (e, a) => {
  for (var t in a || (a = {}))
    b.call(a, t) && l(e, t, a[t]);
  if (o)
    for (var t of o(a))
      m.call(a, t) && l(e, t, a[t]);
  return e;
};
var c = (e, a) => {
  var t = {};
  for (var r in e)
    b.call(e, r) && a.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && o)
    for (var r of o(e))
      a.indexOf(r) < 0 && m.call(e, r) && (t[r] = e[r]);
  return t;
};
import n, { forwardRef as h } from "react";
import k from "../Loader/Loader.js";
const x = h(function(y, w) {
  var s = y, { children: a, variant: t, inverse: r, size: i = "regular", testId: E = "fs-button", loading: f, loadingLabel: g, icon: u, iconPosition: d = "left", disabled: B } = s, v = c(s, ["children", "variant", "inverse", "size", "testId", "loading", "loadingLabel", "icon", "iconPosition", "disabled"]);
  return n.createElement(
    "button",
    p({ ref: w, "data-fs-button": !0, "data-fs-button-inverse": r, "data-fs-button-size": i, "data-fs-button-loading": f, "data-fs-button-variant": t, disabled: B, "data-testid": E }, v),
    n.createElement(
      "div",
      { "data-fs-button-wrapper": !0 },
      f && n.createElement(
        "p",
        { "data-fs-button-loading-label": !0 },
        g,
        n.createElement(k, { variant: t === "primary" && !r ? "light" : "dark" })
      ),
      !!u && d === "left" && n.createElement("span", { "data-fs-button-icon": !0 }, u),
      a && n.createElement("span", null, a),
      !!u && d === "right" && n.createElement("span", { "data-fs-button-icon": !0 }, u)
    )
  );
}), j = x;
export {
  j as default
};
